import { Accordion, FooterPortal, NavbarPortal } from "components";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AssetShell from "../../assets/images/portal/shell-back.png";
import AssetTwopeople from "../../assets/images/portal/group-7.png";
// import AssetRectangle from "../../assets/images/portal/Rectangle.png";
import { FaSearch } from "react-icons/fa";
import KnowledgeBase from "./KnowledgeBase";
import { useDispatch, useSelector } from "react-redux";
import {
  API_URL_kbCategory,
  API_URL_loginByKeycloakCode,
  API_URL_loginByToken,
} from "constants/api";
import { kbCategoryReducers } from "redux/kbCategorySlice";
import { getData, isAuth } from "actions";
import KnowledgeBaseBeranda from "./KnowledgeBaseAccordion";
import jwtDecode from "jwt-decode";
import axios from "axios";
import { AuthContext } from "context/AuthContext";
import { toast } from "react-toastify";

const Beranda = () => {
  const IS_AUTH = isAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const inputRef = useRef();
  const { updateUser, setUpdateUser, datauser } = useContext(AuthContext);

  const { getKbCategoryResult } = useSelector((state) => ({
    getKbCategoryResult: state.kbCategory.getKbCategoryResult,
  }));

  const getKbCategory = useCallback(
    async (params) => {
      getData(
        API_URL_kbCategory,
        params,
        { dispatch, redux: kbCategoryReducers },
        "GET_KBCATEGORY",
      );
    },
    [dispatch],
  );

  const handleSubmit = () => {
    navigate("/pertanyaan/pencarian", { state: { search: search } });
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  useEffect(() => {
    const params = `?limit=${9999999}`;
    getKbCategory(params);
  }, []);

  //login by Token
  useEffect(() => {
    // Membuat instance URLSearchParams berdasarkan URL saat ini
    const urlParams = new URLSearchParams(window.location.search);

    // Membaca nilai parameter 'token' dari URL
    const token = urlParams.get("token");
    const code = urlParams.get("code");

    if (code) {
      axios({
        method: "POST",
        data: {
          code: code,
        },
        url: API_URL_loginByKeycloakCode,
      })
        .then((response) => {
          localStorage.setItem("sseccaxds", response.data.access);
          localStorage.setItem("hserfercxz", response.data.refresh);
          setUpdateUser(!updateUser);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (token) {
      // login/check_jwt
      fetch("https://akun.apjii.or.id/login/check_jwt/" + token)
        .then((res) => res.json())
        .then((res) => {
          if (!res.status)
            toast.error(
              `Mohon maaf token authentikasi anda tidak valid, mohon kembali ke SSO APJII untuk melakukan login`,
              {
                position: "top-center",
                autoClose: false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              },
            );

          const dataToken = res.data;

          const email = dataToken.email;

          console.log(`email: ${email}`);

          if (email === null || email === undefined) {
            toast.error(
              `Mohon maaf akun anda tidak memiliki data email, mohon lengkapi data email anda di akun MyApjii supaya bisa menggunakan Aplikasi Tiketing`,
              {
                position: "top-center",
                autoClose: false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              },
            );
          }

          const username =
            dataToken.username !== null ? dataToken.username : email;
          const telp = dataToken.telp !== null ? dataToken.telp : "";
          const mobile = telp;
          axios({
            method: "POST",
            data: {
              email: email,
              username: username,
              mobile: mobile,
              token: token,
            },
            url: API_URL_loginByToken,
          })
            .then((response) => {
              localStorage.setItem("sseccaxds", response.data.access);
              localStorage.setItem("hserfercxz", response.data.refresh);
              setUpdateUser(!updateUser);
            })
            .catch((error) => {
              console.log(error);
            });
        });
    }
  }, []);

  return (
    <>
      <div className="flex flex-col min-h-screen overflow-y-auto text-neutral-700">
        {/* Navbar  */}
        <NavbarPortal current={"Beranda"} />
        {/* block manipulasi gradient  */}
        <div className="bg-sky-800 h-20 md:h-40 border-none"></div>
        {/* Button Tiket and Style */}
        <div className="h-80 md:h-80 bg-gradient-to-b from-sky-800 to-black border-none ">
          {/* disini naik turun konten judul dan gambar menggunakan mt  */}
          <div className="mx-auto max-w-[90rem] px-8 mt-[-5rem]">
            <div className="flex flex-wrap justify-center lg:justify-between mx-auto">
              <div id="buttontiket" className="flex flex-col gap-2 mt-7">
                <p className="text-white text-4xl md:text-5xl font-bold mb-4">
                  Layanan Tiketing
                </p>
                <p className="text-white text-4xl md:text-5xl">
                  Untuk Anggota APJII
                </p>

                {IS_AUTH !== false ? (
                  <Link
                    to={"/buattiket"}
                    className="btn-createticket py-2 mt-4 text-2xl"
                  >
                    Buat Tiket
                    <div className="btn2-createticket"></div>
                  </Link>
                ) : (
                  <Link
                    to={"https://akun.apjii.or.id"}
                    className="btn-createticket py-2 mt-4 text-2xl"
                  >
                    Buat Tiket
                    <div className="btn2-createticket"></div>
                  </Link>
                )}
              </div>

              <div
                id="img"
                className="hidden lg:block relative h-80 w-[35rem] mr-14"
              >
                <img
                  src={AssetShell}
                  className=" absolute z-20 h-[10rem] w-[10rem] right-5 top-[-4rem]"
                  alt="shell"
                />
                <img
                  src={AssetShell}
                  className=" absolute z-20 h-[10rem] w-[10rem] right-[22rem] top-[-4rem]"
                  alt="shell"
                />
                <img
                  src={AssetShell}
                  className=" absolute z-20 h-[10rem] w-[10rem] right-5 top-[12rem]"
                  alt="shell"
                />
                <img
                  src={AssetShell}
                  className=" absolute z-1 h-[10rem] w-[10rem] right-[22rem] top-[12rem]"
                  alt="shell"
                />
                <img
                  src={AssetTwopeople}
                  className="absolute z-30 right-16 bottom-[-2rem] w-[75%]"
                  alt="twopeople"
                />
              </div>
            </div>
          </div>
        </div>
        {/* Input Pertanyaan */}
        <div className="flex justify-center -mt-2">
          <div className="relative w-full mx-4 md:w-1/2 bottom-6">
            <div className="px-2 py-2 bg-white rounded-xl border shadow-2xl">
              <input
                type="text"
                id="pertanyaan"
                value={search}
                ref={inputRef}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={handleKeyDown}
                className="bg-white text-gray-800 w-full py-4 px-4 pr-16 border-2 border-sky-200 rounded-lg focus:outline-none focus:border-sky-500 focus:drop-shadow-2xl"
                placeholder="Ada Pertanyaan? Ketik pertanyaan Anda di sini"
              />
            </div>
            <button
              onClick={handleSubmit}
              className="absolute right-3 top-3 py-4 px-4 bg-sky-600 rounded-lg"
            >
              <FaSearch className="text-white text-xl" />
            </button>
          </div>
        </div>
        {/* subjudul & Content */}
        <main className="flex flex-grow mb-4">
          <div id="pertanyaanumum" className="text-center w-full">
            <p className="font-bold text-2xl md:text-3xl mb-6 w-full">
              Kategori Pertanyaan Umum
            </p>

            <div className="mx-4 md:mx-28 lg:mx-52 flex flex-col gap-3">
              {getKbCategoryResult.results &&
                getKbCategoryResult.results.map((item, index) => (
                  <div key={index}>
                    <Accordion
                      title={item.name}
                      content={<KnowledgeBaseBeranda category={item.id} />}
                    />
                  </div>
                ))}
            </div>
          </div>
        </main>

        <FooterPortal />
      </div>
    </>
  );
};

export default Beranda;
